import { z } from "zod";

export const signInFormSchema = z.object({
  id: z.int().min(1).nullable(),

  pin: z.string().regex(/^\d{6}$/, "PIN must be exactly 6 digits"),
});

export type SignInForm = z.infer<typeof signInFormSchema>;
